ixModuleRouting("impactx.combibudget", {
    "/combibudget/overview": {
        template: '<ixa-combi-budget-overview-list></ixa-combi-budget-overview-list>',
        templateUrl: "modules/combibudget/templates/overviewlist.html",
        process: "ViewCombiBudgets",
        controller: "CombiBudgetOverviewListCtrl",
        controllerAs: "combiBudgetOverviewListCtrl",
    },
    "/combibudget/ctu/:id": {
        template: "<ixa-combi-budget-ctu-list></ixa-combi-budget-ctu-list>",
        templateUrl: "modules/combibudget/templates/ctulist.html",
        process: "ViewCombiBudgets",
        controller: "CombiBudgetCTUListCtrl",
        controllerAs: "combiBudgetCTUListCtrl",
    },
    "/combibudget/ctt/:id": {
        template: "<ixa-combi-budget-ctt-list></ixa-combi-budget-ctt-list>",
        templateUrl: "modules/combibudget/templates/cttlist.html",
        process: "ViewCombiBudgets",
        controller: "CombiBudgetCTTListCtrl",
        controllerAs: "combiBudgetCTTListCtrl",
    },
    "/combibudget/edit/:id/:mode/:usrId": {
        template: "<ixa-combi-budget-edit></ixa-combi-budget-edit>",
        templateUrl: "modules/combibudget/templates/combibudgetedit.tmpl.html",
        process: "EditCombiBudgets",
        controller: "CombiBudgetEditCtrl",
        controllerAs: "combiBudgetEditCtrl",
    },
});
